import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import { RouteError } from "../../../shared/components/RouteError";
import { RoutePending } from "../../../shared/components/RoutePending";

const searchSchema = z.object({
  dateFrom: z.string().optional(),
  dateTo: z.string().optional(),
  locationIds: z.array(z.string()).optional(),
  executorIds: z.array(z.string()).optional(),
});

/**
 * @purpose Read fleet and operations KPIs to decide where mechanics are needed
 * @primary KPI dashboard
 * @persona xavi-coo, paola-admin-belora
 */
export const Route = createFileRoute("/app/c/$customerSlug/reporting/kpi-ops/")(
  {
    validateSearch: searchSchema,
    errorComponent: ({ error }) => <RouteError error={error} />,
    pendingComponent: RoutePending,
  },
);
